export default __webpack_public_path__ + "static/media/motor2.32ff7378.png";